import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  var _a;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const availableContent = [
    { label: t("mimecastv2.content_types.archive_message_view"), value: "ARCHIVE_MESSAGE_VIEW" },
    { label: t("mimecastv2.content_types.archive_search"), value: "ARCHIVE_SEARCH" },
    { label: t("mimecastv2.content_types.audit_events"), value: "AUDIT_EVENTS" },
    { label: t("mimecastv2.content_types.dlp"), value: "DLP" },
    { label: t("mimecastv2.content_types.message_release"), value: "MESSAGE_RELEASE" },
    { label: t("mimecastv2.content_types.rejection"), value: "REJECTION" },
    { label: t("mimecastv2.content_types.search"), value: "SEARCH" },
    { label: t("mimecastv2.content_types.ttp_attachment_protection"), value: "TTP_ATTACHMENT_PROTECTION" },
    { label: t("mimecastv2.content_types.ttp_impersonation_protect"), value: "TTP_IMPERSONATION_PROTECT" },
    { label: t("mimecastv2.content_types.ttp_url"), value: "TTP_URL" },
    { label: t("mimecastv2.content_types.siem"), value: "SIEM" }
  ];
  const contentTypes = ((_a = formData.contentTypes) == null ? void 0 : _a.value) || INITIAL_FORMDATA.availableContents.value;
  const [contentTypeVal, setContentTypeVal] = useState(false);
  const handleSubmit = () => {
    let error = false;
    if (contentTypes.length === 0) {
      setContentTypeVal(true);
      error = true;
    }
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: t("common.validation.polling_interval_invalid"),
        nice_message: t("common.validation.polling_interval_min")
      });
      error = true;
    }
    if (!error) {
      setFormError(null);
      onChange({ target: { name: "contentTypes", value: contentTypes } });
      onSubmit();
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, t("mimecastv2.subscribe.log_types_label")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "contentTypes",
        id: "contentTypes",
        onChange: (selected) => {
          onChange({ target: { name: "contentTypes", value: selected } });
        },
        options: availableContent,
        value: contentTypes || ""
      }
    ),
    contentTypeVal && contentTypes.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "contentTypes", style: { color: "red" } }, t("mimecastv2.subscribe.select_log_type")),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("mimecastv2.subscribe.content_types_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("mimecastv2.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
